import { loadScript, guid } from '../utility';

const DEFAULTS =   {
  attrSelector: '[data-cl-hubspot-form]',
  hsformsSrc: 'https://js.hsforms.net/forms/v2.js',
  portalId: '1697621',
  formId: undefined,
  css: '',
};

export default class HubspotForm {

  constructor(el, options = DEFAULTS) {
    this.el = el;
    // Add a unique ID, in case there are multiple forms on the same page.
    this.el.id = guid();
    // This is the formId used by Hubspot.
    this.formId = this.el.dataset.clHubspotForm;
    // Simply merge options and default ones
    this.options = {...DEFAULTS, ...options};

    // See: https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options
    this.formOptions = {
      target: `${this.options.attrSelector}[id="${this.el.id}"]`,
      formInstanceId: this.el.id,
      portalId: this.options.portalId,
      formId: this.formId,
      css: this.options.css,
    };

    this.setRequiredClasses();
    this.insertScript();
  }

  /**
   * Loads the Hubspot API script, then creates the form.
   */
  async insertScript() {
    // window.hbspt could be loaded by another hubspot tracking script.
    // window.hbspt.forms gets added with the forms/v2.js script.
    if (!window.hbspt || !window.hbspt.forms) {
      await loadScript(this.options.hsformsSrc);
    }

    window.hbspt.forms.create(this.formOptions);
  }

  /**
   * Adds any additional required classes.
   * When using the inline embed code from Hubspot,
   * the Hubspot API automatically creates an element with a .hbspt-form class.
   * When you define a specific target for the form, the class does not get added,
   * so we need to manually add it to maintain our existing styles.
   */
  setRequiredClasses() {
    this.el.classList.add('hbspt-form');
  }
}
